import type { OrderFormValues } from '../typings'

type ComputeTargetRangeArgs = {
  initialValues: OrderFormValues
  currentValues: OrderFormValues
}

export function computeAutomaticRange(
  args: ComputeTargetRangeArgs,
): uui.domain.client.rm.RecurrenceTargetRange | undefined {
  const { initialValues, currentValues } = args

  // if the order was not a recurrence and now it is return
  if (
    initialValues.recurrenceSettings.recurrencePeriod.recurrenceType === 'NO_REPEAT' &&
    currentValues.recurrenceSettings.recurrencePeriod.recurrenceType !== 'NO_REPEAT'
  ) {
    return 'REPEAT'
  }

  if (
    initialValues.recurrenceSettings.recurrencePeriod.recurrenceType !== 'NO_REPEAT' &&
    currentValues.recurrenceSettings.recurrencePeriod.recurrenceType === 'NO_REPEAT'
  ) {
    return 'NOT_REPEAT'
  }
}
